function getAge(dateOne, dateTwo) {
  //get the age of a person on the date on dateTwo if born on dateOne where both are in the form YYYY-MM-DD
  //dateOne is the date of birth
  //dateTwo is the date to calculate the age on
  //split the dates into arrays
  let dateOneArray = dateOne.split("-");
  let dateTwoArray = dateTwo.split("-");
  //get the years, months and days
  let years = dateTwoArray[0] - dateOneArray[0];
  let months = dateTwoArray[1] - dateOneArray[1];
  let days = dateTwoArray[2] - dateOneArray[2];
  //if the days are negative, then we need to borrow from the months
  if (days < 0) {
    months--;
    days += 30;
  }
  //if the months are negative, then we need to borrow from the years
  if (months < 0) {
    years--;
    months += 12;
  }

  return years;
}

module.exports = getAge;
